<template>
  <section class="hd-wap-recommend">
    <div class="wp">
      <div class="wp-inner">
        <div class="page index">
          <img src="~assets/images/recommend/icon_1.png" alt="" class="logo js-animate animated" data-animate="fadeInDown">
          <p class="title f18 js-animate animated" data-animate="fadeInDown">海渡职校</p>
          <img src="~assets/images/recommend/img_wenzi.png" alt="" class="info js-animate animated" data-animate="fadeInDown">
          <div class="buttons">
            <a href="javascript:;" @click="$router.push(`download`)" class="button js-animate animated" data-animate="fadeInLeft">
              <i class="icon iphone"></i>
              <span class="f14">iPhone下载</span>
            </a>
            <a href="javascript:;" @click="$router.push(`download`)" class="button js-animate animated" data-animate="fadeInLeft">
              <i class="icon android"></i>
              <span class="f14">Android下载</span>
            </a>
          </div>
          <div class="arrow" style="bottom:0.133rem;">
            <img src="~assets/images/recommend/icon-arrow-down.png" alt="">
          </div>
        </div>
        <div class="page part">
          <h1 class="f18 js-animate animated" data-animate="fadeInLeft">
            专业工业机器人学习资源只在<span style="color: #24b2f9;" class="f18">海渡职校</span></h1>
          <div class="line"></div>
          <div class="sliderContainer">
            <slider width="100%" height="100%" :interval="3000" :speed="1000" :control-btn="false" :auto="true">
              <slider-item>
                <img src="~assets/images/recommend/icon_shuji.png" alt="" style="width: 4.8rem;margin-top: 1.467rem;">
                <h3 class="f13">专业的配套教材</h3>
                <p>哈尔滨工业大学机器人领域专家教师及职业教育领域优秀教师潜心编纂。工业机器人技术专业"十三五"规划教材,工业机器人应用人才培养指定用书。</p>
              </slider-item>
              <slider-item>
                <img src="~assets/images/recommend/icon_live.png" alt="" style="width: 4.8rem;margin-top: 1.467rem;">
                <h3 class="f13">丰富的视频教学洗印</h3>
                <p>行业资深高级工程师现场录制,结合实物装备,针对知识点细化分解</p>
              </slider-item>
            </slider>
          </div>
          <div class="arrow">
            <img src="~assets/images/recommend/icon-arrow-down-black.png" alt="">
          </div>
        </div>
        <div class="page part" style="background:#f4f8fb;">
          <h1 class="f18 js-animate animated" data-animate="fadeInLeft">全网独一无二</h1>
          <div class="line"></div>
          <p class="js-animate animated" data-animate="bounceIn">哈尔滨工业大学、哈工大机器人集团联合打造;免费优质课程、专注工业机器人教育;工业机器人学习从入门到精通</p>
          <img src="~assets/images/recommend/img_duyiwuer.png" alt="" class="js-animate animated" data-animate="slideInRight">
          <div class="arrow">
            <img src="~assets/images/recommend/icon-arrow-down-black.png" alt="">
          </div>
        </div>
        <div class="page part">
          <div class="item">
            <h1 class="f18 js-animate animated" data-animate="fadeInLeft">全新学习体验</h1>
            <div class="line"></div>
            <p class="js-animate animated" data-animate="bounceIn">提供工业机器人领域轻量学习内容,每一块碎片时间都可以被更好地利用;除了轻量学习内容,还有更为丰富的进阶式学习系统,工业机器人学习,拾级而上;结合个性推荐、学习任务管理等多项功能、帮助你有效提升学习效果,成就机器人指挥官</p>
            <img src="~assets/images/recommend/img_xuexitiyan.png" alt="" class="js-animate animated" data-animate="rollIn">
          </div>
          <div class="arrow">
            <img src="~assets/images/recommend/icon-arrow-down-black.png" alt="">
          </div>
        </div>
        <div class="page part" style="background:#f4f8fb;">
          <h1 class="f18 js-animate animated" data-animate="fadeInLeft">签到送积分,自由兑换书籍和教学资源</h1>
          <div class="line"></div>
          <p class="js-animate animated" data-animate="bounceIn">每天签到都有积分送,连续签到更有玫瑰和游轮邀请好友送400积分,8个好友加入就能免费的书籍</p>
          <img src="~assets/images/recommend/img_qiandao.png" alt="" style="width: 7.253rem;" class="js-animate animated" data-animate="bounceInUp">
          <div class="arrow">
            <img src="~assets/images/recommend/icon-arrow-top-black.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Slider, SliderItem } from "vue-easy-slider";
import "@/assets/js/zepto.fullpage.js";
export default {
  name: "",
  data() {
    return {};
  },
  components: {
    Slider,
    SliderItem
  },
  mounted() {
    $(".wp-inner").fullpage({
      change: function(e) {
        // 移除动画属性
        // $('.page').eq(e.cur).find('.js-animate').each(function() {
        //   $(this).removeClass($(this).data('animate')).hide();
        // });
      },
      afterChange: function(e) {
        // $('.page').eq(e.cur).find('.js-animate') // .each(function() { // $(this).addClass($(this).data('animate')).show(); // });
      }
    });
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "~assets/styles/animate.css";
.wp {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  .page {
    position: relative;
    .arrow {
      position: absolute;
      bottom: -0.533rem;
      width: 0.533rem;
      left: 4.97rem;
      img {
        width: 100%;
      }
    }
  }
  .title {
  }
  .index {
    background: url(~assets/images/recommend/img_bg.png) center no-repeat;
    background-size: cover;
    text-align: center;
    padding-top: 1.067rem;
    box-sizing: border-box;
    .logo {
      width: 6.667rem;
      margin: 0 auto;
    }
    .title {
      color: #fff;
      margin: 0.267rem auto;
    }
    .info {
      width: 4.667rem;
    }
    .buttons {
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: 1.867rem;
      .button {
        width: 6.267rem;
        height: 1.28rem;
        border: 1px solid #fff;
        color: #fff;
        display: -webkit-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.133rem;
        margin: 0.4rem auto 0;
        .icon:after {
          content: "";
          width: 0.427rem;
          height: 0.52rem;
          display: block;
          margin-right: 0.467rem;
        }
        .android:after {
          background: url(~assets/images/recommend/icon_anzuo.png) center
            no-repeat;
          background-size: cover;
        }
        .iphone:after {
          background: url(~assets/images/recommend/icon_ios.png) center
            no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .part {
    text-align: center;
    padding: 2.133rem 0.467rem 0;
    h1 {
      color: #333333;
    }
    .line {
      width: 1.6rem;
      height: 2px;
      background: #333333;
      margin: 0.427rem auto;
    }
    p {
      color: #626b73;
      line-height: 1.5;
      margin-top: 0.32rem;
    }
    img {
      width: 100%;
      margin: 0.867rem auto;
    }
    .sliderContainer {
      width: 100%;
      height: 10.4rem;
    }
  }
}

/* 箭头 */

@-webkit-keyframes start {
  0%,
  30% {
    opacity: 0.2;
    -webkit-transform: translate(0, 0.133rem);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate(0, 0);
  }
  100% {
    opacity: 0.2;
    -webkit-transform: translate(0, -0.133rem);
  }
}

@keyframes start {
  0%,
  30% {
    opacity: 0.2;
    transform: translate(0, 0.133rem);
  }
  60% {
    opacity: 1;
    transform: translate(0, 0);
  }
  100% {
    opacity: 0.2;
    transform: translate(0, -0.133rem);
  }
}

.start {
  position: fixed;
  left: 50%;
  margin-left: -17px;
  top: 98%;
  margin-top: -34px;
  width: 0.667rem;
  height: 0.667rem;
  b {
    position: absolute;
    left: 50%;
    top: 0.133rem;
    margin-left: -9px;
    width: 0.507rem;
    height: 0.32rem;
    background: url(~assets/images/recommend/arrow.png);
    background-size: 100% 100%;
    -webkit-animation: start 1.5s infinite ease-in-out;
    animation: start 1.5s infinite ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// Recommend.vue?ed536c22